import { __assign } from './../../external_lib/tslib/tslib.es6.js';
import Icon from '../../Atoms/Icon.js';
import React__default from 'react';

function DownArrow(props) {
    return (React__default.createElement(Icon, __assign({ svg: function (_a) {
            var color = _a.color;
            return "<svg\n    viewBox=\"0 0 12 8\"\n    fill=\"none\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n  >\n    <path d=\"M6 7.4L0 1.4L1.4 0L6 4.6L10.6 0L12 1.4L6 7.4Z\" fill=\"".concat(color || '#999', "\" />\n  </svg>");
        } }, props)));
}

export { DownArrow as default };
//# sourceMappingURL=down-arrow.icon.js.map
